import { UnitSystem } from '../types';

// Constants
const CM_TO_INCH = 0.393701;
const INCH_TO_CM = 2.54;
const KG_TO_LB = 2.20462;
const LB_TO_KG = 0.453592;
const M_TO_FT = 3.28084;
const FT_TO_M = 0.3048;

// Convert stored value (Metric) to Display Value (System dependent)
export const toDisplayLength = (cm: number, system: UnitSystem): number => {
  if (system === 'metric') return Math.round(cm); // cm
  return parseFloat((cm * CM_TO_INCH).toFixed(1)); // inches
};

export const toDisplayMeters = (m: number, system: UnitSystem): string => {
  if (system === 'metric') return `${m.toFixed(2)} m`;
  return `${(m * M_TO_FT).toFixed(2)} ft`;
};

export const toDisplayWeight = (kg: number, system: UnitSystem): number => {
  if (system === 'metric') return Math.round(kg); // kg
  return Math.round(kg * KG_TO_LB); // lbs
};

// Convert Input Value (System dependent) to Stored Value (Metric)
export const toStoredLength = (value: number, system: UnitSystem): number => {
  if (system === 'metric') return value;
  return value * INCH_TO_CM;
};

export const toStoredMeters = (value: number, system: UnitSystem): number => {
  if (system === 'metric') return value;
  return value * FT_TO_M;
};

export const toStoredWeight = (value: number, system: UnitSystem): number => {
  if (system === 'metric') return value;
  return value * LB_TO_KG;
};

// Labels
export const getLengthLabel = (system: UnitSystem) => system === 'metric' ? 'cm' : 'in';
export const getWeightLabel = (system: UnitSystem) => system === 'metric' ? 'kg' : 'lb';
export const getTruckDimLabel = (system: UnitSystem) => system === 'metric' ? 'm' : 'ft';